// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"pFQxnTNN","rankingMethodologyWrapper":"KJlQNDup","labelWrapper":"bjeY6B_b","styledLabel":"bIFyF5N1"};